import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import "react-datepicker/dist/react-datepicker.css";

import Input from '../UI/Input';

import { getNeighborhoodUsers } from '../../redux/actions/emailListsActions';
import classes from './BoardMember.module.css';
import DropdownDate from '../UI/DropdownDate/DropdownDate';

const BoardMemberForm = ({boardMember, edit, onSubmit, onCancel, onDelete}) => {
  const history = useHistory();
  const auth = useSelector(state => state.auth);
  const emailLists = useSelector(state => state.emailLists)
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(undefined)
  const [searchVal, setSearchVal] = useState(boardMember.name === undefined ? '' : boardMember.name);
  const [userListContent, setUserListContent] = useState(null);
  const [termEndDate, setTermEndDate] = useState(boardMember.term_end_date)
  
  const BOARD_ROLES = [
    "President", 
    "Vice President",
    "Treasurer", 
    "Assistant Treasurer", 
    "Secretary",
    "Trustee"
  ];

  const schema = Yup.object({
    role_type: Yup.string()
      .min(3, 'Invalid role specified')
      .max(128, "Invalid role specified"),
    // term_end_date: Yup.date()
    //   .min(new Date(), "Date can't be in the past")
    //   .required('Required', "Must specify a term end date"),
    user_id: Yup.number()
      .required("Must specify the person that will be the board member")
  });

  const formik = useFormik({
    initialValues: {
      id: boardMember.id,
      user_id: boardMember.user_id,
      role_type: boardMember.role_type,
      term_end_date: boardMember.term_end_date
    },
    validateOnChange: true,
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(`BoardMemberForm: onSubmit: formikErrors: ${formik.errors}`, values)
      onSubmit({...values, term_end_date: termEndDate})
    }
  })

  useEffect(() => {
    // debugger;
    if (emailLists.neighborhood_users.length === 0) {
      dispatch(getNeighborhoodUsers());
    }
  }, [])

  const saveSelectedUser = (user) => {
    // alert(`${user.first_name} ${user.last_name}`)
    setSelectedUser(user);
    setSearchVal(user.first_name + ' ' + user.last_name)
    formik.setFieldValue('user_id', user.id)
    setUserListContent(null)
  }
  const renderContentBody = (userList) => {
    const partialList = userList.map(user => {
      return <li className={classes.NameListItem} key={`${user.id}-${user.first_name}-${user.last_name}`} onClick={() => saveSelectedUser(user)}>{user.first_name} {user.last_name}</li>
    })
    return (
      <ul>{partialList}</ul>
    )
  }
  const renderRoleTypes = () => {
    const roleOptions = BOARD_ROLES.map((role) => {
      return <option key={role} value={role}>{role}</option>
    })
    return roleOptions;
  }
  const showInlineUserList = (event) => {
    const eventVal = event.target.value;
    event.stopPropagation();
    const tempSearchVal = event.target.value.toLowerCase();
    if (tempSearchVal.trim().length === 0) {
      setUserListContent(null)
    }
    if (emailLists.neighborhood_users.length > 0) {
      const newFilteredItems = emailLists.neighborhood_users.filter(user => {
        const tempName = user.first_name.toLowerCase() + ' ' + user.last_name.toLowerCase();
        return tempName.includes(tempSearchVal)
      })
      // console.log(`Found: ${newFilteredItems.length} possible matches`)
      setUserListContent(renderContentBody(newFilteredItems))
    } else {
      setUserListContent(null)
    }
    setSearchVal((prevValue) => {return eventVal})
  }

  const termEndChange = (date) => {
    setTermEndDate(date)
    console.log(date.toLocaleString())
  }

  const renderDeleteButton = () => {
    if (edit) {
      return (
        <Button style={{marginLeft: '40px'}} type="button" onClick={() => onDelete()}>
          <FontAwesomeIcon
            icon={faTrash}
            size="1x"
            className={[classes.Icon, classes.DeleteButton].join(' ')}
          />
          Delete
        </Button>
      )
    }
    return null;
  }

  const renderTitle = () => {
    let titleText = "Add Board Member";
    if (edit) {
      titleText = `Editing ${boardMember.name}'s Info`;
    }
    return <h5 style={{textAlign: 'center'}}>{titleText}</h5>
  }
  return (
    <div>
      <Row>
        <Col sm={3}></Col>
        <Col sm={6}>
          <h5 style={{color: 'red', textAlign: 'center'}}>{auth.error}</h5>
          {renderTitle()}
          <Form
            onSubmit={formik.handleSubmit}
            className={classes.Form}
            autoComplete="off"
          >
            <InputGroup className={classes.InputGroup}>
              <Input
                id='user_model'
                name='user_model'
                label='System User'
                placeholder="Specify the name of the user"
                // value={formik.values.user_id === undefined ? "" : `${selectedUser.first_name} ${selectedUser.last_name}`}
                value={searchVal}
                changed={showInlineUserList}
                // blur={formik.handleBlur}
                // errors={formik.errors.user_id}
                // touched={formik.touched.user_id}
              />
              {/* <input type="hidden" name="user_id" value={selectedUser} /> */}
            </InputGroup>
            <InputGroup>
              <InputGroup.Prepend></InputGroup.Prepend>
              <InputGroup.Append>
                <div style={{ maxHeight: 'calc(40vh - 200px)', overflowY: 'auto' }}>
                  {userListContent}
                </div>
              </InputGroup.Append>
            </InputGroup>

            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text id="role_type">Role</InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                id="role_type" name="role_type"
                as="select" 
                value={formik.values.role_type}
                onChange={formik.handleChange}
                isInvalid={formik.errors.role_type}
              >
                <option value="0">[Select]</option>
                {renderRoleTypes()}
                {/* <option value="Forms">Forms</option>
                <option value="Misc.">Misc.</option>
                <option value="Informational Documents">Informational Documents</option>
                <option value="Informational Links">Informational Links</option> */}
                {/* {renderSiteAdminOptions()} */}
              </Form.Control>
              <Form.Control.Feedback className={classes.ErrorMessage} type='invalid'>
                {formik.errors.site_document_type_id}
              </Form.Control.Feedback>
            </InputGroup>
            <InputGroup className={classes.InputGroup}>
              <InputGroup.Prepend className={classes.InputGroup}>
                <InputGroup.Text id="datetime_id_">* Term End Date</InputGroup.Text>
              </InputGroup.Prepend>
              <DropdownDate startDate={termEndDate} currentValue={formik.values.term_end_date} numYears={4} onChange={termEndChange} />
              <Form.Control.Feedback className={classes.ErrorMessage} type='invalid'>
                {formik.errors.term_end_date}
              </Form.Control.Feedback>
            </InputGroup>
            <InputGroup>
              <InputGroup.Prepend className={classes.InputGroup} />
              <InputGroup.Append>
                    <Button type="submit" >{(edit ? "Update Member" : "Create Member")}</Button>
                    <Button style={{marginLeft: '5px'}} type="cancel" onClick={onCancel} >Cancel</Button>
                    {renderDeleteButton()}
              </InputGroup.Append>
            </InputGroup>

          </Form>
        </Col>
        <Col sm={3}></Col>
      </Row>
    </div>
  );
}

export default BoardMemberForm;